import DataGrid from '@app/components/organisms/DataGrid/DataGrid'
import { VOUCHER_TYPE } from '@app/constant/VoucherTypeConstant'
import getParameters from '@app/libs/getParameters'
import { usePage } from '@inertiajs/inertia-react'
import Grid from '@mui/material/Grid'
import { useTranslation } from 'react-i18next'

export default function VoucherUsed({ vouchersUsed, total }) {
  const { t, i18n } = useTranslation()
  const { url } = usePage()
  const urlObj = new URL(url, location.origin)

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <DataGrid
          enableIndexColumn
          columns={[
            {
              id: 'name',
              Header: t('VOUCHERS.VOUCHER_TABLE'),
              accessor: 'name',
              type: 'string',
              disableFilters: true,
            },
            {
              id: 'code',
              Header: t('VOUCHERS.CODE'),
              accessor: 'code',
              type: 'string',
              disableFilters: true,
            },
            {
              id: 'used_at',
              Header: t('VOUCHERS.TIME'),
              accessor: 'used_at',
              type: 'dateRange',
            },
            {
              id: 'type',
              Header: t('VOUCHER.VOUCHER_TYPE'),
              accessor: ({ type }) => t(`CODES.${type.toUpperCase()}`),
              type: 'singleSelect',
              typeCategories: 'Type',
              options: [
                { value: VOUCHER_TYPE.STANDARD, name: t('VOUCHERS.STANDARD') },
                { value: VOUCHER_TYPE.PREMIUM, name: t('VOUCHERS.PREMIUM') },
              ],
              autoHide: true,
            },
            {
              id: 'price',
              Header: t('VOUCHERS.PRICE'),
              accessor: 'price',
              type: 'number',
              disableFilters: true,
            },
          ]}
          data={vouchersUsed}
          enableCollapseFilter={false}
          exportable={{
            enableExport: true,
            url: 'merchant.used.voucher.export',
            params: { ...getParameters(urlObj), locale: i18n.language },
          }}
          exportTotal={total}
          routeName="merchant.vouchers.used"
        />
      </Grid>
    </Grid>
  )
}
